import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const serviceSubTypeList = createAsyncThunk('serviceSubType/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `service_sub_type`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'type_id': data?.type_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const serviceSubTypeDetails = createAsyncThunk('serviceSubType/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `service_sub_type/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addServiceSubType = createAsyncThunk('serviceSubType/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'service_sub_type',
            data: {
                "type_id": data?.values?.type,
                "sub_type_name": data?.values?.name,
                "status": data?.values?.status
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateServiceSubType = createAsyncThunk('serviceSubType/update', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'service_sub_type',
            data: {
                "sub_type_id": data?.values?.id,
                "type_id": data?.values?.type,
                "sub_type_name": data?.values?.name,
                "status": data?.values?.status
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delServiceSubType = createAsyncThunk('serviceSubType/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `service_sub_type/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const serviceSubType = createSlice({
    name: 'serviceSubType',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(serviceSubTypeList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(serviceSubTypeList.fulfilled, (state, action) => {
            state.loading = false;
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });
        builder.addCase(serviceSubTypeList.rejected, (state) => {
            state.loading = false;
            state.list = [];
        });

        builder.addCase(serviceSubTypeDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default serviceSubType.reducer;